import { createContext, useContext, useState, useCallback, useMemo, useLayoutEffect } from 'react';
import { SIDEBAR_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from './styles';

const STORAGE_KEY = 'sidebar-collapsed';

const getInitialCollapsed = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored === null ? true : stored === 'true';
    } catch {
        return true;
    }
};

const setSidebarCssVar = collapsed => {
    const width = collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH;
    document.documentElement.style.setProperty('--sidebar-width', `${width}px`);
};

const SidebarContext = createContext({ isCollapsed: true, toggleCollapsed: () => {} });

export const SidebarProvider = ({ children }) => {
    const [isCollapsed, setIsCollapsed] = useState(getInitialCollapsed);

    useLayoutEffect(() => {
        setSidebarCssVar(isCollapsed);
    }, [isCollapsed]);

    const toggleCollapsed = useCallback(() => {
        setIsCollapsed(prev => {
            const next = !prev;
            try {
                localStorage.setItem(STORAGE_KEY, String(next));
            } catch {
                // ignore
            }
            return next;
        });
    }, []);

    const value = useMemo(() => ({ isCollapsed, toggleCollapsed }), [isCollapsed, toggleCollapsed]);

    return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
};

export const useSidebar = () => useContext(SidebarContext);
